"use client";

import { Popover } from "@focal/ui-kit";

import { useState } from "react";
import { cn } from "@/lib/utils";
import { Client, Participant, User, SuggestedParticipants } from "@/types";
import { ConversationPersonCard } from "@/components/pages/Conversations/ConversationsDetails/ConversationPersonTag/ConversationPersonCard";
import {
  ConversationPersonPopoverPaginated,
  UpdateParticipantData,
} from "@/components/pages/Conversations/ConversationsDetails/ConversationPersonTag/ConversationPersonPopoverPaginated";

interface ConversationPersonTagProps {
  participant?: Partial<Participant>;
  clients?: Client[];
  users?: User[];
  onSelectParticipant: (data: UpdateParticipantData) => void;
  onDeleteParticipant?: (participantId: string) => void;
  disableRedirect?: boolean;
  disableRemove?: boolean;
  disableUsers?: boolean;
  isLoading?: boolean;
  participants?: Partial<Participant>[];
  suggestedParticipants?: SuggestedParticipants;
  showAssignmentStatus?: boolean;
  className?: string;
  conversationId?: string | null;
}

export const ConversationPersonTag = ({
  participant,
  onSelectParticipant,
  onDeleteParticipant,
  disableRedirect,
  disableRemove,
  disableUsers,
  isLoading,
  participants = [],
  suggestedParticipants,
  showAssignmentStatus,
  className,
  conversationId,
}: ConversationPersonTagProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Popover open={open} onOpenChange={setOpen} modal>
        <div
          className={cn(
            "flex items-center m-0 relative group overflow-hidden rounded-xl transition-colors",
            className,
          )}
          data-cy="participant-tag"
        >
          <ConversationPersonCard
            onDeleteParticipant={onDeleteParticipant}
            participant={participant}
            disableRedirect={disableRedirect}
            disableRemove={disableRemove}
            disableUsers={disableUsers}
            isLoading={isLoading}
            showAssignmentStatus={showAssignmentStatus}
          />
          <ConversationPersonPopoverPaginated
            fuzzy
            participant={participant}
            onSelectParticipant={onSelectParticipant}
            onCloseModal={() => setOpen(false)}
            open={open}
            disableUsers={disableUsers}
            participants={participants}
            suggestedParticipants={suggestedParticipants}
            conversationId={conversationId}
          />
        </div>
      </Popover>
    </>
  );
};
